import styled from 'styled-components';
import devices from 'src/viewLayer/styling/mixins/media-queries';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';

export const AppComponentWithBackground = styled.div`
  // uncomment when desktop can use dark mode
  // background-color: ${({ theme }) => theme.color.surface.container.background};
  background-color: ${ tokens.color.theme.light.surface.container.background };
  height: 100%;
`;

AppComponentWithBackground.defaultProps = {
  theme: {
    color: {
      surface: {
        container: {
          background: 'none'
        }
      }
    }
  }
};

export const LoginBusinessPageContainer = styled.div`
  background-color: ${({ theme }) => theme.color.surface.layer.background};

  @media only screen and ${devices.fromsmall} {
    background-color: ${({ theme }) => theme.color.surface.container.background};
  }
`;
